export default {
    ALL: 'ALL',
    DITERIMA: 'DITERIMA',
    PASIEN_BELUM_MASUK: 'PASIEN_BELUM_MASUK',
    DIRUJUK_KETEMPAT_LAIN: 'DIRUJUK_KETEMPAT_LAIN',
    TIDAK_JADI_DATANG: 'TIDAK_JADI_DATANG',

}
